module.exports = __webpack_public_path__ + "img/shoye-QLayout.7e9b3e86.png";